<template>
  <router-view/>
</template>

<style>
body{
  font-weight: bolder;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


.flex-wr{
  cursor: pointer;
}

</style>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const isMobile = ref(false)

// 检测设备类型的函数

// 检测设备类型的函数
const checkDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  
  // 改进的移动设备检测，包括更全面的苹果设备检测
  const mobileDevices = [
    /android/, 
    /iphone|ipad|ipod/,  // 合并苹果设备检测
    /blackberry/, 
    /windows phone/, 
    /mobile/,
    /macintosh/ // 添加Macintosh检测，因为iPadOS 13+的Safari会报告Macintosh
  ]
  
  // 特别处理iPad Pro
  const isiPadPro = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  
  isMobile.value = mobileDevices.some(device => userAgent.match(device)) || isiPadPro

  console.log("isMobile--", isMobile.value)
  
  // 如果需要重定向
  // if (isMobile.value) {
  //   window.location.href = 'https://shop.wulianwanjia.com/web/index.html#/'
  // }
}



// 在组件挂载时检测
onMounted(() => {
  checkDevice()
  // 如果需要响应窗口大小变化，可以添加 resize 事件监听
  window.addEventListener('resize', checkDevice)
})

// 在组件卸载前移除事件监听
onBeforeUnmount(() => {
  window.removeEventListener('resize', checkDevice)
})
</script>
